import { render, staticRenderFns } from "./West.vue?vue&type=template&id=22f40131&lang=pug&"
import script from "./West.vue?vue&type=script&lang=js&"
export * from "./West.vue?vue&type=script&lang=js&"
import style0 from "./West.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports